export function notifyHostCallback<Value>(
  callback: ((value: Value) => void) | undefined,
  value: Value
) {
  if (!callback) {
    return;
  }
  try {
    Promise.resolve(callback(value)).catch(() => undefined);
  } catch {
    // Host callback failures must not change completed SDK state.
  }
}
